module.exports = __webpack_public_path__ + "media/laurel-gitlen.6b935362.mp4";